import { useEffect, useState } from 'react';
import { AiFillEdit } from 'react-icons/ai';
import Contact from './Contact';

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL

const Contacts = ({ currentUser, jobId, color }) => {
    const [addContact, setAddContact] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [notes, setNotes] = useState('');
    const getContacts = async () => {
        const res = await fetch(`${REACT_APP_BACKEND_URL}/jobs/contacts/get/${jobId}/`, {
            method: "GET",
            headers: {
                "Authorization": `Token ${currentUser.token}`
            }
        });
        const data = await res.json();
        console.log(data)
        setContacts(data.data)
    };
    useEffect(() => {
        getContacts()
    }, [])
    const handleAdd = async (e) => {
        e.preventDefault();
        const reqBody = {
            first_name: e.target.firstName.value,
            last_name: e.target.lastName.value,
            email: e.target.email.value,
            phone: e.target.phone.value,
            notes: e.target.notes.value
        }
        const res = await fetch(`${REACT_APP_BACKEND_URL}/jobs/contacts/add/${jobId}/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Token ${currentUser.token}`
            },
            body: JSON.stringify(reqBody)
        })
        const data = await res.json()
        if (data.status_code === 'success') {
            setContacts(prev=>{
                prev.push(data.data)
                return prev
            })
            setAddContact(false)
        }
    };
    const onElemFocus = (e) => {
        e.target.parentElement.classList.add("focusWithText");
    };

    const onElemBlur = (e) => {
        if (e.target.value === "") {
            e.target.parentElement.classList.remove("focusWithText");
        }
    };
    useEffect(() => {
        const fieldArray = ['firstName', 'lastName', 'email', 'phone', 'notes']
        const myArr = []
        if (addContact) {
            for (let field of fieldArray) {
                let fieldHTML = document.getElementById('add_' + field);
                myArr.push(fieldHTML)
                fieldHTML.addEventListener('focus', onElemFocus);
                fieldHTML.addEventListener('blur', onElemBlur);
            }
        }
        return () => {
            if (addContact) {
                for (let field of myArr) {
                    field.removeEventListener('focus', onElemFocus);
                    field.removeEventListener('blur', onElemBlur);
                }
            }
        }
    }, [addContact]);
    return (
        <div className='misc-box-container'>
            <div className='contacts-box gap-4'>
                {contacts.map((c, i) => <Contact key={`contact_${i}`} c={c} currentUser={currentUser} />)}
                {
                    addContact
                        ?
                        <div className='p-3'>
                            <form onSubmit={(e)=>{handleAdd(e)}}>
                            <div className="inputGroup inputGroup1 addContact">
                                <input type="text" id="add_firstName" name='firstName' maxLength="256" value={firstName} onChange={(e)=>setFirstName(e.value)} autoComplete="off" required />
                                <p className="helper helper1">First Name</p>
                            </div>
                            <div className="inputGroup inputGroup1 addContact">
                                <input type="text" id="add_lastName" name='lastName' maxLength="256" value={lastName} onChange={(e)=>setLastName(e.value)} autoComplete="off" />
                                <p className="helper helper1">Last Name</p>
                            </div>
                            <div className="inputGroup inputGroup1 addContact">
                                <input type="text" id="add_email" name='email' maxLength="256" value={email} onChange={(e)=>setEmail(e.value)} autoComplete="off" />
                                <p className="helper helper1">hello@example.com</p>
                            </div>
                            <div className="inputGroup inputGroup1 addContact">
                                <input type="text" id="add_phone" name='phone' maxLength="256" value={phone} onChange={(e)=>setPhone(e.value)} autoComplete="off" />
                                <p className="helper helper1">(888) 888 - 8888</p>
                            </div>
                            <h4>Notes</h4>
                            <div className="inputGroup inputGroup1 addContact">
                                <input type="text" id="add_notes" name='notes' maxLength="256" value={notes} onChange={(e)=>setNotes(e.value)} autoComplete="off" />
                                <p className="helper helper1">Add a role / position</p>
                            </div>
                            <div className='modal-btn-container' style={{color: color.hex==='#ffeb3b'||color.hex===''? '#212121' : 'white'}}>
                                <button type='submit'>Save</button>
                                <button onClick={() => setAddContact(false)}>Cancel</button>
                            </div>
                            </form>
                        </div>
                        :
                        <div className='modal-btn-container' onClick={() => setAddContact(true)} style={{color: color.hex==='#ffeb3b'||color.hex===''? '#212121' : 'white'}}>
                            <button className='mt-2'>
                                + Add a Contact
                            </button>
                        </div>
                }
            </div>
        </div>
    )
};
export default Contacts;